import script from "./UserGoalDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserGoalDetail.vue?vue&type=script&setup=true&lang=ts"

import "./UserGoalDetail.vue?vue&type=style&index=0&id=3167bdb3&lang=scss"

const __exports__ = script;

export default __exports__